// extracted by mini-css-extract-plugin
export default {"title":"AddMoreModal_title__9Qlvq","formItem":"AddMoreModal_formItem__78wwd"};